import { request } from "../../apis";

export const apiGetSkills = (): any =>
  request("get", `/api/skill/list`, null, true);
